/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Server-owned workload sizing classes.
 *
 * @remarks
 *
 * Resource classes are deliberately independent of the language/runtime
 * profile.  In particular, Coding Harness always uses the Medium class even when a
 * caller sends a smaller or absent legacy ``memory_mib`` value.
 */
export const SandboxResourceClass = {
  Medium: "medium",
} as const;
/**
 * Server-owned workload sizing classes.
 *
 * @remarks
 *
 * Resource classes are deliberately independent of the language/runtime
 * profile.  In particular, Coding Harness always uses the Medium class even when a
 * caller sends a smaller or absent legacy ``memory_mib`` value.
 */
export type SandboxResourceClass = ClosedEnum<typeof SandboxResourceClass>;

/** @internal */
export const SandboxResourceClass$inboundSchema: z.ZodNativeEnum<
  typeof SandboxResourceClass
> = z.nativeEnum(SandboxResourceClass);
/** @internal */
export const SandboxResourceClass$outboundSchema: z.ZodNativeEnum<
  typeof SandboxResourceClass
> = SandboxResourceClass$inboundSchema;
